import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count", "blueprint"]
  static values = { previewUrl: String }

  connect() {
    document.addEventListener("turbo:before-stream-render", this.boundSync = () => {
      setTimeout(() => this.syncAndRefresh(), 300)
    })
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.boundSync)
  }

  syncAndRefresh() {
    // Grab the last stable_id input — it contains the most up-to-date blueprint
    const inputs = document.querySelectorAll('input[name="refine_inline_criterion[stable_id]"]')
    const lastInput = inputs[inputs.length - 1]
    if (lastInput?.value && this.lastStableId !== lastInput.value) {
      this.lastStableId = lastInput.value
      this.blueprintTarget.value = lastInput.value
      this.refreshCount()
    }
  }

  refreshCount() {
    if (!this.previewUrlValue || !this.hasBlueprintTarget) return

    const value = this.blueprintTarget.value
    if (!value) return

    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
    fetch(`${this.previewUrlValue}?stable_id=${encodeURIComponent(value)}`, {
      headers: { "X-CSRF-Token": csrfToken }
    })
      .then(r => {
        if (!r.ok) return
        return r.text()
      })
      .then(count => {
        if (count && this.hasCountTarget) this.countTarget.textContent = count
      })
  }
}
